import Delay from '@/webgl/core/Delay'
import Signal from '@/webgl/core/Signal'
import GameWorld from '@/webgl/runner/GameWorld'
import { IRunnerRenderer } from '@/webgl/runner/interfaces/IRunnerRenderer'
import { ScenarioSetup } from '@/webgl/runner/scenarios/ScenarioSetup.types'
import { IGameSegment } from '@/webgl/runner/systems/SequencingSystem'

export default class Tooltip implements IGameSegment {
  onComplete = new Signal<void>()
  world: GameWorld
  renderer: IRunnerRenderer

  constructor(readonly id: string) {}

  init(world: GameWorld, renderer: IRunnerRenderer, _setup: ScenarioSetup): void {
    this.world = world
    this.renderer = renderer
  }

  start(): void {
    // show tooltip in UI
    this.world.state.setTooltip(this.id)
    Delay(200).then(() => {
      this.onComplete.emit()
    })
  }

  stop(): void {
    // clean up tooltip
    this.world.state.setTooltip(null)
  }
}
